/*
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2022-12-27 10:08:56
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-05-31 11:22:04
 * @FilePath: \合联\oms\src\api\operation_modules\messageBoard.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import axios from "@/libs/api.request";

export const getList = params => {
  return axios.request({
    url: "/api/messageBoard/dataList",
    method: "get",
    params
  });
};

export const examined = data => {
  return axios.request({
    url: "/messageBoard/examined",
    method: "put",
    data
  });
};

export const detail = id => {
  return axios.request({
    url: "/messageBoard/info/" + id,
    method: "get",
  });
};